import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Themphuongtien from "components/Tracuuthongtin/Themphuongtien.js";
import Capnhatphuongtien from "components/Tracuuthongtin/Capnhatphuongtien.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const ptcolumn = [
  { field: "stt", headerName: "stt", width: 80, headerAlign: "center" },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "taitrong",
    headerName: "Tải trọng",
    width: 100,
    headerAlign: "center",
  },
  {
    field: "succhua",
    headerName: "Sức chứa",
    width: 100,
    headerAlign: "center",
  },
  {
    field: "dmloaihinhvantai",
    headerName: "Loại hình vận tải",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sophuhieu",
    headerName: "Số phù hiệu",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "phuhieu",
    headerName: "Phù hiệu",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 120,
    headerAlign: "center",
    //valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 120,
    headerAlign: "center",
    //valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "mauphuhieu",
    headerName: "Mẫu phù hiệu",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "coquancapphep",
    headerName: "Cơ quan cấp phép",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "trangthai",
    headerName: "Trạng thái",
    width: 180,
    headerAlign: "center",
  },
];
export default function Danhmucphuongtien() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [phuongtien_id, setPhuongtien_id] = React.useState(0);
  const [donviql_id, setDonviql_id] = React.useState(0);
  const [openthem, setOpenthem] = React.useState(false);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const openthempt = () => {
    setOpenthem(true);
  };
  const handleClose = () => {
    setOpenthem(false);
    getdonvitheouser();
  };
  const handleClosecapnhat = () => {
    setOpencapnhat(false);
    getdonvitheouser();
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdonvitheouser = () => {
    var url =
      Config.backend +
      "/api/Donvi/getdonviquanlytheouser?dmloaidonvi_id=1&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) {
          getphuongtiendonvi(data[0].id);
          setDonviql_id(data[0].id);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphuongtiendonvi = (donvi_id) => {
    if (donvi_id > 0) {
      var url =
        Config.backend +
        "/api/Donvi/getphuongtientheodonvi?donvi_id=" +
        donvi_id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setPhuongtien(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  React.useEffect(() => {
    getdonvitheouser();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "11%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 32 }}
            onClick={openthempt}
          >
            Thêm mới
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={phuongtien}
            columns={ptcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            onRowClick={(params) => {
              setPhuongtien_id(params.row.id);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpencapnhat(true);
              }
            }}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm phương tiện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themphuongtien donviql_id={donviql_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opencapnhat}
          onClose={handleClosecapnhat}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật phương tiện
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosecapnhat} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatphuongtien
                    phuongtien_id={phuongtien_id}
                    donviql_id={donviql_id}
                  />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
    </GridContainer>
  );
}
